import { storeSet, } from '@cmd/ui-utilities';
const { reducer: dashboardsIdReceivedReducer, selector: dashboardsIdReceivedSelector, updateAction: updateDashboardsIdReceived, urlUpdater: dashboardsIdReceivedUrlUpdater, } = storeSet('dashboardsIdReceived', false);
export { dashboardsIdReceivedReducer, dashboardsIdReceivedSelector, updateDashboardsIdReceived, dashboardsIdReceivedUrlUpdater, };
